// extracted by mini-css-extract-plugin
export default {"main":"allCampaigns_main__d8KPI","headline":"allCampaigns_headline__j8n66","sideline":"allCampaigns_sideline__TcYZc","upcoming":"allCampaigns_upcoming__akzDI"};